module.exports = __webpack_public_path__ + "d1def937bdd4dea0f65aa1a2b986b090.jpg";